module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-selector weui-cell",
    class: {
      'weui-cell_select': !_vm.readonly, 'weui-cell_select-after': _vm.title
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label",
    style: ({
      width: _vm.$parent.labelWidth,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    attrs: {
      "for": ("vux-selector-" + _vm.uuid)
    }
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-select",
    staticStyle: {
      "color": "red"
    },
    style: ({
      direction: _vm.direction,
      color: _vm.color
    }),
    attrs: {
      "id": ("vux-selector-" + _vm.uuid),
      "ddd": _vm.color,
      "name": _vm.name
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showPlaceholder) ? _c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": typeof _vm.value === 'undefined' && _vm.placeholder
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.fixIos) ? _c('option', {
    attrs: {
      "disabled": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.processOptions), function(one) {
    return _c('option', {
      domProps: {
        "value": one.key
      }
    }, [_vm._v(_vm._s(one.value))])
  })], 2)]) : _c('div', {
    staticClass: "weui-cell__ft vux-selector-readonly"
  }, [_vm._v("\n    " + _vm._s(_vm._f("findByKey")(_vm.value, _vm.processOptions)) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c51194b6"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/selector/index.vue
// module id = 548
// module chunks = 4